<template>
  <div>
    <g-master name="reportparameter"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              @action="masterAction"
              ref="master"
              :useMultipart="true"
              :beforeSend="master.beforeSend"
              modalWidth="80%"
    >
    <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='INACTIVO'">
                <a-tag color="red">{{text}}</a-tag>
              </div>
              <div v-if="text ==='ACTIVO'">
                <a-tag color="blue">{{text}}</a-tag>
              </div>
              <div v-if="text ==='BLOQUEADO'">
                <a-tag color="purple">{{text}}</a-tag>
              </div>
    </span>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Param. en iReport')">
              <a-input
                v-decorator="['field_ireport', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown v-bind="fiOptions"
                        endpoint="hierarchy_lookup"
                        :label="$t('Tipo de dato')"
                        :formItemConfig="fiOptions"
                        :selectedObj.sync="tipoDatoSeleccionado"
                        :decorator="['id_h_type_parameter', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="tipo_dato">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('SQL dinámico')">
              <a-textarea :disabled="isVisibleByLista" autoSize
                          v-decorator="['sql_dynamic', { rules: [{ required: isRequiredByLista, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Nombre columna ID')">
              <a-input
                :disabled="isVisibleByLista"
                v-decorator="['col_id_name', { rules: [{ required: isRequiredByLista, message: 'Valor requerido'}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown v-bind="fiOptions"
                        :disabled="isVisibleByLista"
                        endpoint="hierarchy_lookup"
                        :label="$t('Tipo columna ID')"
                        :formItemConfig="fiOptions"
                        :decorator="['col_id_h_type', { rules: [{ required: isRequiredByLista, message: 'Valor requerido' }] }]"
                        :params="tipo_columna_id">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Columnas en LOV')">
              <a-input
                :disabled="isVisibleByLista"
                v-decorator="['col_others', { rules: [{ required: isRequiredByLista, message: 'Valor requerido'}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Subir archivo')">
              <a-upload
                name="profile_file"
                :before-upload="beforeUpload"
                :fileList="master.uploads.subreport_file"
                :remove="() => { master.uploads.subreport_file = [] }">
                <a-button :disabled="isVisibleBySubreporte" style="width: 100%">Seleccionar archivo</a-button>
              </a-upload>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Subir archivo fuente')">
              <a-upload
                name="profile_file"
                :before-upload="beforeUploadSource"
                :fileList="master.uploads.source_subrte_file"
                :remove="() => { master.uploads.source_subrte_file = [] }">
                <a-button :disabled="isVisibleBySubreporte" style="width: 100%">Seleccionar archivo</a-button>
              </a-upload>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Obligatorio')" :has-feedback="false">
              <a-checkbox v-decorator="['mandatory', {valuePropName: 'checked'}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown v-bind="fiOptions"
                        endpoint="hierarchy_lookup"
                        :label="$t('Estado')"
                        :formItemConfig="fiOptions"
                        :decorator="['status', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="estado">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Encriptado')" :has-feedback="false">
              <a-checkbox v-decorator="['encrypted', {valuePropName: 'checked'}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Dinámico')" :has-feedback="false">
              <a-checkbox v-decorator="['parameter_dynamic', {valuePropName: 'checked'}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Traducciones del parámetro" key="1">
        <report-parameter-tl v-if="idReportParameter" :id_report_parameter="idReportParameter"/>
        <span v-else>Seleccione un parámetro para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['id_report'],
    computed: {
      parentData () {
        return {
          id_report: this.id_report
        }
      },
      idReportParameter () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id_report_parameter : null
      }
    },
    watch: {
      tipoDatoSeleccionado () {
        if (this.tipoDatoSeleccionado.text === 'LISTA') {
          this.isVisibleByLista = false
          this.isRequiredByLista = true
        } else {
          this.isVisibleByLista = true
          this.isRequiredByLista = false
          this.$refs.master.modal.form.setFieldsValue({
            sql_dynamic: '',
            col_id_name: '',
            col_id_h_type: '',
            col_others: ''
          })
        }
        if (this.tipoDatoSeleccionado.text === 'SUBREPORTE') {
          this.isVisibleBySubreporte = false
        } else {
          this.isVisibleBySubreporte = true
        }
      }
    },
    data () {
      return {
        loadingBtns: {},
        tipoDatoSeleccionado: {},
        isVisibleByLista: true,
        isRequiredByLista: false,
        isVisibleBySubreporte: true,
        estado: {
          h_lookup_type: 'ESTADO_SNB',
          use_code: true
        },
        tipo_dato: {
          h_lookup_type: 'TIPO_PARAMETROS_REPORT'
        },
        tipo_columna_id: {
          h_lookup_type: 'TIPO_PARAMETROS_REPORT'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          uploads: {
            subreport_file: [],
            source_subrte_file: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.subreport_file.length > 0) {
              data.subreport_file = this.master.uploads.subreport_file[0]
            }

            if (this.master.uploads.source_subrte_file.length > 0) {
              data.source_subrte_file = this.master.uploads.source_subrte_file[0]
            }

            if (data.mandatory) {
              data.mandatory = 'Y'
            } else {
              data.mandatory = 'N'
            }

            if (data.encrypted) {
              data.encrypted = 'S'
            } else {
              data.encrypted = 'N'
            }

            if (data.parameter_dynamic) {
              data.parameter_dynamic = 'S'
            } else {
              data.parameter_dynamic = 'N'
            }
            return data
          },
          endpoint: 'report_parameter',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    if (!JsUtils.isEmpty(record.source_subrte_file_content_typ)) {
                      return true
                    } else {
                      return false
                    }
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_report_parameter] === record.id_report_parameter
                  }
                }
              ]
            },
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id_report_parameter'
            },
            columns: [
              {title: '#', dataIndex: 'id_report_parameter', sorter: true},
              {title: 'Param. en iReport', dataIndex: 'field_ireport', sorter: true},
              {title: 'Tipo de dato', dataIndex: 'type_parameter_desc', sorter: true},
              {title: 'SQL dinámico', dataIndex: 'sql_dynamic', sorter: true},
              {title: 'Nombre de columna ID', dataIndex: 'col_id_name', sorter: true},
              {title: 'Tipo de columna ID', dataIndex: 'col_type_desc', sorter: true},
              {title: 'Columnas en LOV', dataIndex: 'col_others', sorter: true},
              {title: 'Obligatorio', dataIndex: 'mandatory_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                width: 130,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Encriptado', dataIndex: 'encrypted_desc', sorter: true},
              {title: 'Param. dinámico', dataIndex: 'paramater_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'field_ireport'},
            {name: 'id_h_type_parameter'},
            {name: 'sql_dynamic'},
            {name: 'col_id_name'},
            {name: 'col_id_h_type'},
            {name: 'col_others'},
            {name: 'mandatory'},
            {name: 'status'},
            {name: 'encrypted'},
            {name: 'parameter_dynamic'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.subreport_file = [file]
        }
        return false
      },
      beforeUploadSource (file) {
        if (this.validateFileSource(file)) {
          this.master.uploads.source_subrte_file = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['jasper']
        const isJpgOrPng = file.name.split('.')
        if (!array.includes(isJpgOrPng[isJpgOrPng.length - 1])) {
          this.$message.error('Solo se pemiten documentos tipo jasper')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      validateFileSource (file) {
        const array = ['jrxml']
        const isJpgOrPng = file.name.split('.')
        if (!array.includes(isJpgOrPng[isJpgOrPng.length - 1])) {
          this.$message.error('Solo se pemiten documentos tipo jrxml')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      download (id_report_parameter) {
        this.loadingBtns[id_report_parameter] = id_report_parameter
        this.loadingBtns = Object.assign({}, this.loadingBtns)
        this.httpClient.getInstance().get('report_parameter/download/' + id_report_parameter, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = response.headers['x-nombre-archivo']
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            delete this.loadingBtns[id_report_parameter]
            this.loadingBtns = Object.assign({}, this.loadingBtns)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (action.record.mandatory === 'Y') {
              this.$refs.master.modal.form.setFieldsValue({
                mandatory: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                mandatory: false
              })
            }

            if (action.record.encrypted === 'S') {
              this.$refs.master.modal.form.setFieldsValue({
                encrypted: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                encrypted: false
              })
            }

            if (action.record.parameter_dynamic === 'S') {
              this.$refs.master.modal.form.setFieldsValue({
                parameter_dynamic: true
              })
            } else {
              this.isConsEmpVisible = false
              this.$refs.master.modal.form.setFieldsValue({
                parameter_dynamic: false
              })
            }
            if (action.record.type_parameter_desc === 'LISTA') {
              this.isVisibleByLista = false
              this.isRequiredByLista = true
            } else {
              this.isVisibleByLista = true
              this.isRequiredByLista = false
            }
            if (action.record.type_parameter_desc === 'SUBREPORTE') {
              this.isVisibleBySubreporte = false
            } else {
              this.isVisibleBySubreporte = true
            }

            break

          case 'masterCreate':
            this.master.uploads.source_subrte_file = []
            this.master.uploads.subreport_file = []
            this.isVisibleBySubreporte = true
            this.isVisibleByLista = true
            break
          case 'download':
            this.download(action.record.id_report_parameter)
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Report/ReportParameter.vue